import {
    registerPaymentModalHelper
} from "../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper";

class PaymentManager {

    listener = false;

    constructor() {
    }

    buyCredits() {
        registerPaymentModalHelper.openForPricingPremium().then(() => {
            this.modalToShow = null;
        });
    }

    buyProAndUltimate() {
        registerPaymentModalHelper.openOnlyProAndUltimate().then(() => {
            this.modalToShow = null;
        });
    }
}

export default new PaymentManager()